import {
  REQUEST_INFLUENCERS,
  RECEIVE_INFLUENCERS,
  UPDATE_INFLUENCER_PARAMS,
  RECEIVE_INFLUENCER,
  RECEIVE_INFLUENCER_VIDEOS,
  RECEIVE_INFLUENCER_PRODUCTS,
  RECEIVE_INFLUENCER_BRANDS,
  REQUEST_INFLUENCER_BRANDS,
  REQUEST_INFLUENCER_VIDEOS,
  REQUEST_INFLUENCER_PRODUCTS,
  FINDING_VIDEOS,
  REQUEST_INFLUENCER_USER,
  RECEIVE_INFLUENCER_USER,
  REQUEST_INFLUENCER_DEMOGRAPHICS,
  RECEIVE_INFLUENCER_DEMOGRAPHICS,
  REQUEST_INFLUENCER_SENTIMENT,
  RECEIVE_INFLUENCER_SENTIMENT,
  REQUEST_INFLUENCER_DAILY_TRACKINGS,
  RECEIVE_INFLUENCER_DAILY_TRACKINGS,
  RESET_FILTERS_INFLUENCERS,
  INFLUENCER_PAGE_STATES,
} from "./influencer_actions";

// import { RECEIVE_CURRENT_SESSION } from '../entry/session_actions';
// import { RECEIVE_SERVER_ERRORS } from '../errors/error_actions';

export const influencers = (state = [], payload = {}) => {
  const { type, influencers, influencer } = payload;
  switch (type) {
    case RECEIVE_INFLUENCERS:
      return influencers;
    case RECEIVE_INFLUENCER:
      return [...state, influencer];
    default:
      return state;
  }
};

export const filters = {
  platform: [],
  note: [],
  pov: [],
  demographic: {
    age_range: [],
    ethnicity: [],
    gender: [],
  },
  category: [],
  product: [],
  brand: [],
  country: [],
  subscribers: {
    radio: true,
    value: null,
  },
  videos: {
    radio: true,
    value: null,
  },
};

export const _nullParams = {
  sort: "latest_platform_video_published_at",
  desc: true,
  search: "",
  page: 1,
  tab: "My Creators",
  filters,
  date: null,
  trending: false,
  validEmail: false,
  vyrillVerified: false,
};

export const influencerParams = (state = _nullParams, payload = {}) => {
  const { type, params } = payload;
  switch (type) {
    case RESET_FILTERS_INFLUENCERS:
      return { ...state, filters };
    case UPDATE_INFLUENCER_PARAMS:
      return { ...state, ...params };
    // case RECEIVE_CURRENT_SESSION:
    //   return _nullParams;
    default:
      return state;
  }
};

const _nullData = {
  totalPages: 1,
  loading: false,
  loadignVideos: false,
  loadingProucts: false,
  count: 0,
  filters,
  videos: {
    trending: [],
    recent: [],
    sponsored: [],
  },
  sentiment: {
    positive: [],
    negative: [],
  },
  products: [],
  pictures: [],
  searched: false,
  findingVideos: false,
  demographics: {
    age: [],
    ethnicity: [],
    gender: [],
    demographics_data: [],
  },
  loadingDemographics: false,
  loadingVyrillData: false,
  loaded_for: null,
  statistics: [],
  engagementIndex: {
    average_views_per_video: [],
    average_engagement_index: [],
    influencer_performance_index: [],
  },
  loadingEngagementIndex: false,
  loadingCreatorBrands: false,
  creatorBrands: [],
};

export const influencerData = (state = _nullData, payload = {}) => {
  const {
    type,
    data,
    videos,
    products,
    pictures,
    categories,
    id,
    findingVideos,
    demographics,
    sentiment,
    statistics,
    engagementIndex,
    creatorBrands,
  } = payload;
  switch (type) {
    case REQUEST_INFLUENCERS:
      return { ...state, loading: true };
    case RECEIVE_INFLUENCERS:
      return { ...state, ...data };
    case REQUEST_INFLUENCER_VIDEOS:
      return { ...state, loadingVideos: id };
    case RECEIVE_INFLUENCER_VIDEOS:
      return { ...state, videos, loadingVideos: false };
    // case RECEIVE_SERVER_ERRORS:
    //   return { ...state, loadingVideos: false };
    case REQUEST_INFLUENCER_PRODUCTS:
      return { ...state, loadingProducts: id, loadingVyrillData: id };
    case RECEIVE_INFLUENCER_PRODUCTS:
      return {
        ...state,
        products,
        pictures,
        categories,
        loadingProducts: false,
        loadingVyrillData: false,
      };
    case REQUEST_INFLUENCER_BRANDS:
      return { ...state, loadingCreatorBrands: true };
    case RECEIVE_INFLUENCER_BRANDS:
      return {
        ...state,
        loadingCreatorBrands: false,
        creatorBrands,
      };
    case FINDING_VIDEOS:
      return { ...state, findingVideos };
    case REQUEST_INFLUENCER_DEMOGRAPHICS:
      return { ...state, loadingDemographics: true };
    case RECEIVE_INFLUENCER_DEMOGRAPHICS:
      return { ...state, demographics, loadingDemographics: false };
    case REQUEST_INFLUENCER_SENTIMENT:
      return { ...state, loadingVyrillData: true };
    case RECEIVE_INFLUENCER_SENTIMENT:
      return { ...state, sentiment, loadingVyrillData: false };
    case REQUEST_INFLUENCER_DAILY_TRACKINGS:
      return { ...state, loadingEngagementIndex: true };
    case RECEIVE_INFLUENCER_DAILY_TRACKINGS:
      return { ...state, engagementIndex, loadingEngagementIndex: false };
    case RECEIVE_INFLUENCER:
      return { ...state, ...{ statistics } };
    default:
      return state;
  }
};

const _nullInfluencerUser = {
  loadingUser: false,
  user: null,
};

export const influencerUser = (state = _nullInfluencerUser, payload = {}) => {
  const { type, user } = payload;
  switch (type) {
    case REQUEST_INFLUENCER_USER:
      return { ...state, loadingUser: true };
    case RECEIVE_INFLUENCER_USER:
      return { ...state, loadingUser: false, user };
    default:
      return state;
  }
};

const _nullInfluencerStates = {
  isCategoryPage: true,
};

export const InfluencerPageStates = (
  state = _nullInfluencerStates,
  { type, status }
) => {
  switch (type) {
    case INFLUENCER_PAGE_STATES:
      return status;
    default:
      return state;
  }
};
